module.exports = __webpack_public_path__ + "img/l200.2ec0cf97.png";